import {staticUrl} from "../constants";
import {createCycle, createRing, createLabel, createFieldOfView, applyTexture} from "../three-helper";
import * as Three from 'three';

class Teleport3D {
    _imgSrc = null;
    _colors = {
        'circle': {
            init: 'rgb(190, 190, 190)',
            active: 'rgb(32, 222, 64)'
        },
        'cylinder': {
            init: 'rgb(255, 255, 255)',
            active: 'rgb(32, 222, 64)'
        },
        'ring': {
            init: 'rgb(190, 190, 190)',
            active: 'rgb(30, 30, 30)'
        }
    };

    constructor(imgSrc) {
        this._imgSrc = imgSrc || staticUrl('common/images/teleport.png');
    }

    render3D(height, text, areaString = '0 m', preview = false, optimazerMode, measurementMode) {
        if (!preview && !optimazerMode) {
            let geometry = new Three.CylinderGeometry( 25, 25, height, 50, 1, true);
            let material = new Three.MeshBasicMaterial({
                side: Three.DoubleSide,
                depthWrite: false,
                color: this._colors['cylinder'].init,
                transparent: true,
                opacity: 1
            });

            return applyTexture(material, {uri: this._imgSrc}).then(() => {
                let cylinder = new Three.Mesh( geometry, material );

                cylinder.renderOrder = 1;
                cylinder.name = 'cylinder';

                const circle = createCycle(this._colors['circle'].init);

                circle.name = 'circle';
                circle.rotation.x = Math.PI /2;
                circle.position.y -= height / 2 - 1;
                circle.renderOrder = 1;

                const label = createLabel(text, areaString, 0, 0, 0, 32, "rgba(255, 255, 255, 1)");

                label.name = 'label';
                label.renderOrder = 1;

                let pivot = new Three.Group();
                pivot.name = 'teleport';
                pivot.add(cylinder, circle);

                if(!measurementMode){
                    pivot.add(label);
                }

                pivot.userData.actions = {
                    select: this._changeColor.bind(this, pivot, true),
                    deselect: this._changeColor.bind(this, pivot, false)
                };

                return pivot;
            })
        } else {
            const circle = createCycle(this._colors['ring'].init, 50);

            circle.name = 'circle';
            circle.rotation.x = Math.PI /2;
            circle.position.y -= height / 2 - 1;
            circle.renderOrder = 1;

            const ring = createRing(this._colors['ring'].init, 25, 50);

            ring.name = 'ring';
            ring.rotation.x = Math.PI / 2;
            ring.position.y -= height / 2 - 2;
            ring.renderOrder = 1;
            window.ring = ring;

            const fov = createFieldOfView(75);

            fov.name = 'fov';
            fov.rotation.x = Math.PI / 2;
            fov.position.y -= height / 2 - 4;
            fov.renderOrder = 1;
            fov.visible = false;

            let pivot = new Three.Group();

            pivot.name = 'teleport';

            if(optimazerMode){
                circle.visible = false;
                pivot.add(circle);
            }else{
                pivot.add(circle, ring, fov);
            }

            pivot.userData.actions = {
                select: this._changePreviewColor.bind(this, pivot, true, optimazerMode),
                deselect: this._changePreviewColor.bind(this, pivot, false, optimazerMode)
            };

            return Promise.resolve(pivot);
        }
    }

    _changeColor(pivot, active = false) {
        const objects = pivot.children.filter((_obj) => Object.keys(this._colors).includes(_obj.name));
        const status = active ? 'active' : 'init';

        objects.forEach((object) => {
            const {name} = object;

            object.material.color.setStyle(this._colors[name][status]);
        });

        pivot.active = active;
    }

    _changePreviewColor(pivot, active = false, optimazerMode) {
        if(optimazerMode) return ;
        const circleColor = active ? this._colors['ring']['active'] : this._colors['circle'].init;
        const circle = pivot.children.find((obj) => obj.name === 'circle');
        const ring = pivot.children.find((obj) => obj.name === 'ring');
        const fov = pivot.children.find((obj) => obj.name === 'fov');
        const status = active ? 'active' : 'init';
        const sr = active ? 1.5 : 1;
        const sc = active ? 0.8 : 1;

        circle.material.color.setStyle(circleColor);
        ring.material.color.setStyle(this._colors['ring'][status]);
        circle.scale.set(sc, sc, 1);
        ring.scale.set(sr, sr, 1);
        fov.visible = active;
        pivot.active = active;
    }
}

export default Teleport3D;
